import React from 'react';

type Props = { data: Record<string, any> | Record<string, any>[] };

export default function JsonLd({ data }: Props) {
    return (
        <script
            type="application/ld+json"
            // We stringify here; consumers pass plain objects
            dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
    );
}